import React,{useState} from "react";

export default function MastersPages({
  page, nav, isA, isDB, user, lang, T, C, fmt, today, todayStr,
  companies, setCompanies, custs, setCusts, supps, setSupps,
  prods, setProds, orders, pays, purs, notes, beats, batches,
  accounts, cheques, expenses, users,
  modal, setModal, form, setForm,
  cf, setCf, srch, setSrch, dateFrom, setDateFrom, dateTo, setDateTo,
  gTab, setGTab, selFY, setSelFY,
  loadData, showToast, gc, API,
  myCompany, setMyCompany,
  Bdg, CB, Btn, Inp, Sel, Card, Sc, Row, Bar, Modal,
  UnivFilter, CFbar, dlCSV,
  AddProdToInvoice, InvModal, BankRecon, PhotoScanModal,
  handleOrder, handlePur, addPay, setSubPage, subPage,
  prev, setPrev, payOid, setPayOid,
  nItems, setNItems,
  lowS, suppPays, canAccess,
  NC, NI, SC, CC, editC, editComp, setEditComp,
}){
  // ── Multi-select bulk delete — one Set per entity type, plus a "select mode" toggle
  // so checkboxes stay hidden by default and only appear when actually needed. ──
  const [selMode,setSelMode]=useState({}); // {stock:bool, custs:bool, supps:bool}
  const [selProds,setSelProds]=useState(new Set());
  const [selCusts,setSelCusts]=useState(new Set());
  const [selSupps,setSelSupps]=useState(new Set());
  const toggleSel=(setFn,curr,id)=>{
    const next=new Set(curr);
    next.has(id)?next.delete(id):next.add(id);
    setFn(next);
  };
  const bulkDelete=async(ids,deleteFn,setLocal,localArr,setSel,label)=>{
    if(!ids.length)return;
    if(!window.confirm(`${ids.length} ${label} delete karne hain? Yeh undo nahi ho sakta.`))return;
    setLocal(localArr.filter(x=>!ids.includes(x.id)));
    setSel(new Set());
    let failCount=0;
    for(const id of ids){
      try{ await deleteFn(id); }catch(e){ failCount++; }
    }
    await loadData(true);
    showToast(failCount>0?`⚠️ ${ids.length-failCount}/${ids.length} deleted, ${failCount} failed`:`✅ ${ids.length} deleted!`);
  };
  return(<>

          {/* ── STOCK / INVENTORY ── */}
          {page==="stock"&&<div>
            <UnivFilter placeholder="🔍 Product name, brand..." srch={srch} setSrch={setSrch} dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} companies={companies} cf={cf} setCf={setCf} C={C}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <div style={{fontSize:17,fontWeight:800}}>📦 {T(lang,"inventory")}</div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {isA&&<Btn ch={selMode.stock?"✕ Cancel":"☑️ Select"} oc={()=>{setSelMode({...selMode,stock:!selMode.stock});setSelProds(new Set());}} color={selMode.stock?C.danger:C.sub} out sm/>}
                {isA&&canAccess("batch")&&<Btn ch="📅 Batches" oc={()=>setModal("batches")} color={C.warning} sm/>}
                {isA&&<Btn ch="⬇️ CSV" oc={()=>dlCSV("stock.csv",
                  ["Product","Company","Brand","HSN","MRP","Sale Price","Purchase Price","Stock","Min Stock","Status"],
                  prods.map(p=>[p.name,gc(p.cid)?.short||"",p.brand||"",p.hsn||"",p.mrp||0,p.sp||0,p.pp||0,p.stock,p.min,p.stock<=p.min?"⚠️ Low":"✅ OK"])
                )} color={C.primary} sm/>}
                <Btn ch="🖨️ PDF" oc={()=>{
                  const mc=myCompany||{};const fPDF=prods.filter(p=>cf==="all"||p.cid===cf);
                  const w=window.open("","_blank");
                  try{ w.moveTo(0,0); w.resizeTo(window.screen.availWidth,window.screen.availHeight); }catch(e){}
                  w.document.write(`<!DOCTYPE html><html><head>
  <meta name="viewport" content="width=device-width,initial-scale=1,maximum-scale=2"><title>Inventory Report</title>
                  <style>
                    @page{size:A4;margin:12mm}
                    body{font-family:Arial,sans-serif;font-size:11px;margin:0;padding:15px;max-width:210mm}
                    .firm-header{display:flex;align-items:flex-start;gap:12px;border-bottom:3px solid #1C2B3A;padding-bottom:10px;margin-bottom:10px}
                    .firm-logo{width:55px;height:55px;object-fit:contain;border-radius:6px;border:1px solid #ddd;flex-shrink:0}
                    .firm-logo-ph{width:55px;height:55px;background:#1C2B3A;border-radius:6px;display:flex;align-items:center;justify-content:center;color:#fff;font-size:20px;flex-shrink:0}
                    .firm-name{font-size:17px;font-weight:900;color:#1C2B3A}
                    .firm-sub{font-size:10px;color:#444;margin-top:2px;line-height:1.5}
                    .title-bar{background:#1C2B3A;color:#fff;padding:6px 12px;border-radius:5px;margin-bottom:10px;display:flex;justify-content:space-between;align-items:center}
                    .title-bar span{font-size:13px;font-weight:800}
                    .title-bar small{font-size:9px;color:#94A3B8}
                    table{width:100%;border-collapse:collapse}
                    th{background:#1C2B3A;color:#fff;padding:7px 8px;text-align:left;font-size:10px}
                    td{padding:6px 8px;border-bottom:1px solid #eee;font-size:10px}
                    tr:nth-child(even){background:#f8fafc}
                    .low{color:#EF4444;font-weight:700}
                    .ok{color:#10B981;font-weight:700}
                    .summary{margin-top:12px;padding:8px 12px;background:#f0f4f8;border-radius:5px;font-size:11px}
                    
    @media screen and (max-width:768px){body{padding:5px !important;max-width:100% !important}table{font-size:10px;width:100%}button,a{font-size:12px !important;padding:8px !important;display:block;width:100%;margin-bottom:6px;text-align:center}}
    @media print{button{display:none}}
                  </style></head><body>
                  <button onclick="window.print()" style="padding:8px 20px;background:#2563EB;color:#fff;border:none;border-radius:6px;cursor:pointer;margin-bottom:12px;font-size:12px">🖨️ Print / Save PDF</button>
                  <div class="firm-header">
                    ${mc.logo?`<img src="${mc.logo}" class="firm-logo"/>`:`<div class="firm-logo-ph">🏢</div>`}
                    <div><div class="firm-name">${mc.name||"My Company"}</div>
                    <div class="firm-sub">${mc.address||""}${mc.phone?"<br/>📞 "+mc.phone:""}${mc.gstin?"<br/>GSTIN: "+mc.gstin:""}</div></div>
                  </div>
                  <div class="title-bar"><span>📦 Inventory Report</span><small>Generated: ${new Date().toLocaleString("en-IN",{timeZone:"Asia/Kolkata"})} | Products: ${fPDF.length} | Low Stock: ${fPDF.filter(p=>p.stock<=p.min).length}</small></div>
                  <table>
                    <thead><tr><th>#</th><th>Product</th><th>Company</th><th>Brand</th><th>MRP</th><th>Sale ₹</th><th>Purchase ₹</th><th>Stock</th><th>Min</th><th>Status</th></tr></thead>
                    <tbody>${fPDF.map((p,i)=>{
                      const co=gc(p.cid);
                      const low=p.stock<=p.min;
                      return `<tr>
                        <td>${i+1}</td>
                        <td><b>${p.name}</b></td>
                        <td>${co?.short||"-"}</td>
                        <td>${p.brand||"-"}</td>
                        <td>₹${p.mrp||0}</td>
                        <td>₹${p.sp||0}</td>
                        <td>₹${p.pp||0}</td>
                        <td class="${low?"low":"ok"}">${p.stock}</td>
                        <td>${p.min}</td>
                        <td class="${low?"low":"ok"}">${low?"⚠️ Low Stock":"✅ OK"}</td>
                      </tr>`;
                    }).join("")}</tbody>
                  </table>
                  <div class="summary">
                    <b>Summary:</b> Total Products: ${fPDF.length} | Low Stock Items: <span style="color:red">${fPDF.filter(p=>p.stock<=p.min).length}</span> | Total Stock Value: ₹${fPDF.reduce((s,p)=>s+(p.stock*(p.pp||0)),0).toLocaleString("en-IN")}
                  </div>
                  </body></html>`);
                  w.document.close();
                }} color={C.danger} sm/>
              </div>
            </div>

            {/* Low Stock Alert */}
            {lowS.length>0&&<Card style={{marginBottom:10,border:`1px solid #FECACA`,background:"#FEF2F2"}}>
              <div style={{fontSize:12,fontWeight:700,color:C.danger,marginBottom:5}}>⚠️ Low Stock Alert — {lowS.length} items need reordering</div>
              <div style={{fontSize:11,color:C.sub}}>{lowS.map(p=>p.name).join(", ")}</div>
            </Card>}

            <CFbar/>

            {(()=>{
              const fList=prods.filter(p=>(cf==="all"||p.cid===cf)&&(!srch||p.name?.toLowerCase().includes(srch.toLowerCase())||p.brand?.toLowerCase().includes(srch.toLowerCase())));
              return<>
              {selMode.stock&&fList.length>0&&<Card style={{marginBottom:8,background:"#F8FAFC",display:"flex",justifyContent:"space-between",alignItems:"center",flexDirection:"row"}}>
                <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,fontWeight:600,cursor:"pointer"}}>
                  <input type="checkbox" checked={selProds.size===fList.length&&fList.length>0} onChange={e=>setSelProds(e.target.checked?new Set(fList.map(p=>p.id)):new Set())} style={{width:16,height:16}}/>
                  Select All ({selProds.size} selected)
                </label>
                {selProds.size>0&&<Btn ch={`🗑️ Delete Selected (${selProds.size})`} oc={()=>bulkDelete([...selProds],API.deleteProduct,setProds,prods,setSelProds,"products")} color={C.danger} sm/>}
              </Card>}
              {fList.length===0&&<Card><div style={{textAlign:"center",padding:20,color:C.sub}}>No products found</div></Card>}
              {fList.map(p=>{
                const co=gc(p.cid);
                const low=p.stock<=p.min;
                return<Card key={p.id} style={{marginBottom:8,borderLeft:`3px solid ${low?C.danger:C.success}`}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                    {selMode.stock&&<input type="checkbox" checked={selProds.has(p.id)} onChange={()=>toggleSel(setSelProds,selProds,p.id)} style={{width:18,height:18,marginRight:8,marginTop:2,flexShrink:0}}/>}
                    <div style={{flex:1}}>
                      <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:3}}>
                        <CB co={co}/>
                        <span style={{fontWeight:700,fontSize:13}}>{p.name}</span>
                        {p.brand&&<span style={{fontSize:10,color:C.sub,background:C.bg,padding:"1px 6px",borderRadius:10}}>{p.brand}</span>}
                      </div>
                      <div style={{fontSize:10,color:C.sub}}>HSN: {p.hsn||"—"} • MRP: ₹{p.mrp||0}</div>
                      <div style={{fontSize:11,color:C.text,marginTop:2}}>Sale: <b>₹{p.sp||0}</b> • Purchase: ₹{p.pp||0}</div>
                    </div>
                    <div style={{textAlign:"right",flexShrink:0}}>
                      <div style={{fontSize:18,fontWeight:900,color:low?C.danger:C.success}}>{p.stock}</div>
                      <div style={{fontSize:9,color:C.sub}}>units</div>
                      <Bdg l={low?"⚠️ Low":"✅ OK"} c={low?C.danger:C.success}/>
                    </div>
                  </div>
                  {isA&&<div style={{display:"flex",gap:5,marginTop:8,flexWrap:"wrap"}}>
                    <Btn ch="✏️ Edit" oc={()=>{setModal("prod");setForm({...p});}} color={C.primary} out sm/>
                    <Btn ch="🗑️" oc={async()=>{if(!window.confirm(`Delete "${p.name}"?`))return;setProds(prods.filter(x=>x.id!==p.id));try{await API.deleteProduct(p.id);await loadData(true);showToast("Product deleted!");}catch(e){setProds(prods);showToast("❌ Delete failed: "+(e.message||"Server error"),"err");}}} color={C.danger} out sm/>
                  </div>}
                </Card>;
              })}
              </>;
            })()}
            {isA&&<div style={{position:"fixed",bottom:20,right:20,zIndex:99}}>
              <Btn ch="+ Add Product" oc={()=>{setModal("prod");setForm({gst:18,unit:"PCS",min:10,stock:0,cid:companies[0]?.id||""});}} color={C.primary}/>
            </div>}
          </div>}

          {/* ── CUSTOMERS ── */}
          {page==="custs"&&<div>
            <UnivFilter placeholder="🔍 Customer name, phone..." srch={srch} setSrch={setSrch} dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} companies={companies} cf={cf} setCf={setCf} C={C}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <div style={{fontSize:17,fontWeight:800}}>👥 Customers ({custs.length})</div>
              <div style={{display:"flex",gap:6}}>
                {isA&&<Btn ch={selMode.custs?"✕ Cancel":"☑️ Select"} oc={()=>{setSelMode({...selMode,custs:!selMode.custs});setSelCusts(new Set());}} color={selMode.custs?C.danger:C.sub} out sm/>}
                {!isDB&&<Btn ch="+ Add Customer" oc={()=>{setModal("cust");setForm({});}}/>}
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9,marginBottom:12}}>
              <Sc icon="👥" label="Total" value={custs.length} color={C.primary}/>
              <Sc icon="🔴" label="Outstanding" value={`₹${fmt(custs.reduce((s,c)=>s+(+c.bal||0),0))}`} color={C.danger}/>
            </div>
            {(()=>{
              const fList=custs.filter(c=>(cf==="all"||c.cid===cf||!c.cid)&&(!srch||c.name?.toLowerCase().includes(srch.toLowerCase())||c.phone?.includes(srch)||c.city?.toLowerCase().includes(srch.toLowerCase())));
              return<>
              {selMode.custs&&fList.length>0&&<Card style={{marginBottom:8,background:"#F8FAFC",display:"flex",justifyContent:"space-between",alignItems:"center",flexDirection:"row"}}>
                <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,fontWeight:600,cursor:"pointer"}}>
                  <input type="checkbox" checked={selCusts.size===fList.length&&fList.length>0} onChange={e=>setSelCusts(e.target.checked?new Set(fList.map(c=>c.id)):new Set())} style={{width:16,height:16}}/>
                  Select All ({selCusts.size} selected)
                </label>
                {selCusts.size>0&&<Btn ch={`🗑️ Delete Selected (${selCusts.size})`} oc={()=>bulkDelete([...selCusts],API.deleteCustomer,setCusts,custs,setSelCusts,"customers")} color={C.danger} sm/>}
              </Card>}
              {fList.length===0&&<Card><div style={{textAlign:"center",padding:20,color:C.sub}}>No customers found</div></Card>}
              {fList.map(c=><Card key={c.id} style={{marginBottom:8,borderLeft:`3px solid ${(c.bal||0)>0?C.danger:C.success}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  {selMode.custs&&<input type="checkbox" checked={selCusts.has(c.id)} onChange={()=>toggleSel(setSelCusts,selCusts,c.id)} style={{width:18,height:18,marginRight:8,marginTop:2,flexShrink:0}}/>}
                  <div style={{flex:1}}>
                    <div style={{fontWeight:700,fontSize:13,marginBottom:2}}>{c.name}</div>
                    <div style={{fontSize:11,color:C.sub}}>📞 {c.phone||"—"} • 📍 {c.city||"—"}</div>
                    {c.gstin&&<div style={{fontSize:10,color:C.info}}>GSTIN: {c.gstin}</div>}
                    {(c.credit_limit||0)>0&&<div style={{fontSize:10,fontWeight:700,color:(c.bal||0)>c.credit_limit?C.danger:C.success,marginTop:2}}>💳 Limit: ₹{fmt(c.credit_limit)}{(c.bal||0)>c.credit_limit?" ⚠️ EXCEEDED":""}</div>}
                    {c.loc&&<div style={{fontSize:10,color:C.success}}>📌 Location saved</div>}
                    <div style={{fontSize:9,color:C.sub,marginTop:2}}>Added by: {c.by||"—"}</div>
                  </div>
                  <div style={{textAlign:"right",flexShrink:0}}>
                    {(c.bal||0)>0&&<div style={{fontSize:15,fontWeight:800,color:C.danger}}>₹{fmt(c.bal)}</div>}
                    {(c.bal||0)>0&&<div style={{fontSize:9,color:C.sub}}>due</div>}
                    {(c.paid||0)>0&&<div style={{fontSize:11,color:C.success}}>Paid: ₹{fmt(c.paid)}</div>}
                  </div>
                </div>
                <div style={{display:"flex",gap:5,marginTop:8,flexWrap:"wrap"}}>
                  {c.phone&&<a href={`tel:${c.phone}`} style={{textDecoration:"none"}}><Btn ch="📞 Call" color={C.success} out sm/></a>}
                  {c.loc&&<Btn ch="📍 Map" oc={()=>window.open(c.loc,"_blank")} color={C.info} out sm/>}
                  {!isDB&&<Btn ch="✏️ Edit" oc={()=>{setModal("cust");setForm({...c});}} color={C.primary} out sm/>}
                  {isA&&<Btn ch="🗑️" oc={async()=>{if(!window.confirm(`Delete "${c.name}"?`))return;setCusts(custs.filter(x=>x.id!==c.id));try{await API.deleteCustomer(c.id);await loadData(true);showToast("Customer deleted!");}catch(e){setCusts(custs);showToast("❌ Delete failed: "+(e.message||"Server error"),"err");}}} color={C.danger} out sm/>}
                </div>
              </Card>)}
              </>;
            })()}
          </div>}

          {/* ── SUPPLIERS ── */}
          {page==="supps"&&<div>
            <UnivFilter placeholder="🔍 Supplier name, city..." srch={srch} setSrch={setSrch} dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} companies={companies} cf={cf} setCf={setCf} C={C}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <div style={{fontSize:17,fontWeight:800}}>🏭 Suppliers ({supps.length})</div>
              <div style={{display:"flex",gap:6}}>
                {isA&&<Btn ch={selMode.supps?"✕ Cancel":"☑️ Select"} oc={()=>{setSelMode({...selMode,supps:!selMode.supps});setSelSupps(new Set());}} color={selMode.supps?C.danger:C.sub} out sm/>}
                {isA&&<Btn ch="+ Add Supplier" oc={()=>{setModal("supp");setForm({});}}/>}
              </div>
            </div>
            {(()=>{
              const fList=supps.filter(s=>(cf==="all"||s.cid===cf||!s.cid)&&(!srch||s.name?.toLowerCase().includes(srch.toLowerCase())||s.city?.toLowerCase().includes(srch.toLowerCase())));
              return<>
              {selMode.supps&&fList.length>0&&<Card style={{marginBottom:8,background:"#F8FAFC",display:"flex",justifyContent:"space-between",alignItems:"center",flexDirection:"row"}}>
                <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,fontWeight:600,cursor:"pointer"}}>
                  <input type="checkbox" checked={selSupps.size===fList.length&&fList.length>0} onChange={e=>setSelSupps(e.target.checked?new Set(fList.map(s=>s.id)):new Set())} style={{width:16,height:16}}/>
                  Select All ({selSupps.size} selected)
                </label>
                {selSupps.size>0&&<Btn ch={`🗑️ Delete Selected (${selSupps.size})`} oc={()=>bulkDelete([...selSupps],API.deleteSupplier,setSupps,supps,setSelSupps,"suppliers")} color={C.danger} sm/>}
              </Card>}
              {fList.length===0&&<Card><div style={{textAlign:"center",padding:20,color:C.sub}}>No suppliers found</div></Card>}
              {fList.map(s=><Card key={s.id} style={{marginBottom:8}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  {selMode.supps&&<input type="checkbox" checked={selSupps.has(s.id)} onChange={()=>toggleSel(setSelSupps,selSupps,s.id)} style={{width:18,height:18,marginRight:8,marginTop:2,flexShrink:0}}/>}
                  <div style={{flex:1}}>
                    <div style={{fontWeight:700,fontSize:13,marginBottom:2}}>{s.name}</div>
                    <div style={{fontSize:11,color:C.sub}}>📞 {s.phone||"—"} • 📍 {s.city||"—"}</div>
                    {s.gstin&&<div style={{fontSize:10,color:C.info}}>GSTIN: {s.gstin}</div>}
                    {s.address&&<div style={{fontSize:10,color:C.sub}}>{s.address}</div>}
                  </div>
                  <div style={{textAlign:"right"}}>
                    {(s.bal||0)>0&&<><div style={{fontSize:15,fontWeight:800,color:C.warning}}>₹{fmt(s.bal)}</div><div style={{fontSize:9,color:C.sub}}>payable</div></>}
                    {(s.paid||0)>0&&<div style={{fontSize:11,color:C.success}}>Paid: ₹{fmt(s.paid)}</div>}
                  </div>
                </div>
                {isA&&<div style={{display:"flex",gap:5,marginTop:8,flexWrap:"wrap"}}>
                  {s.phone&&<a href={`tel:${s.phone}`} style={{textDecoration:"none"}}><Btn ch="📞 Call" color={C.success} out sm/></a>}
                  {(+s.bal||0)>0&&<Btn ch="💰 Pay Supplier" oc={()=>{setModal("suppPay");setForm({supp:s.name,amt:+s.bal||0,method:"Cash"});}} color={C.success} sm/>}
                  <Btn ch="📜 History" oc={()=>{setModal("suppPayHistory");setForm({supp:s.name});}} color={C.warning} out sm/>
                  <Btn ch="✏️ Edit" oc={()=>{setModal("supp");setForm({...s});}} color={C.primary} out sm/>
                  <Btn ch="🗑️" oc={async()=>{if(!window.confirm(`Delete "${s.name}"?`))return;setSupps(supps.filter(x=>x.id!==s.id));try{await API.deleteSupplier(s.id);await loadData(true);showToast("Supplier deleted!");}catch(e){setSupps(supps);showToast("❌ Delete failed: "+(e.message||"Server error"),"err");}}} color={C.danger} out sm/>
                </div>}
              </Card>)}
              </>;
            })()}
          </div>}

          {/* ── PRODUCTS ── */}
          {page==="prods"&&<div>
            <UnivFilter placeholder="🔍 Product, brand, HSN..." srch={srch} setSrch={setSrch} dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} companies={companies} cf={cf} setCf={setCf} C={C}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <div style={{fontSize:17,fontWeight:800}}>🧴 Products ({prods.length})</div>
              {isA&&<div style={{display:"flex",gap:6}}>
                <Btn ch="📦 Bulk Upload" oc={()=>setModal("bulkProducts")} color={C.info} out sm/>
                <Btn ch="+ Add Product" oc={()=>{setModal("prod");setForm({gst:18,unit:"PCS",min:10,stock:0,cid:companies[0]?.id||""});}}/>
              </div>}
            </div>
            <CFbar/>
            {(()=>{
              const fList=prods.filter(p=>(cf==="all"||p.cid===cf)&&(!srch||p.name?.toLowerCase().includes(srch.toLowerCase())||p.brand?.toLowerCase().includes(srch.toLowerCase())||p.hsn?.includes(srch)));
              return<>
              {fList.length===0&&<Card><div style={{textAlign:"center",padding:20,color:C.sub}}>No products found</div></Card>}
              {fList.map(p=>{
                const co=gc(p.cid);
                const low=p.stock<=p.min;
                return<Card key={p.id} style={{marginBottom:8,borderLeft:`3px solid ${co?.color||C.primary}`}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                    <div style={{flex:1}}>
                      <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:3}}>
                        <CB co={co}/>
                        <span style={{fontWeight:700,fontSize:13}}>{p.name}</span>
                      </div>
                      <div style={{fontSize:10,color:C.sub}}>Brand: {p.brand||"—"} • HSN: {p.hsn||"—"} • {p.unit||"PCS"}</div>
                      <div style={{display:"flex",gap:10,marginTop:4,fontSize:11}}>
                        <span>MRP: <b>₹{p.mrp||0}</b></span>
                        <span style={{color:C.success}}>Sale: <b>₹{p.sp||0}</b></span>
                        <span style={{color:C.warning}}>GST: {p.gst||18}%</span>
                      </div>
                    </div>
                    <div style={{textAlign:"right",flexShrink:0}}>
                      <div style={{fontSize:18,fontWeight:900,color:low?C.danger:C.success}}>{p.stock}</div>
                      <Bdg l={low?"⚠️ Low":"✅ OK"} c={low?C.danger:C.success}/>
                    </div>
                  </div>
                  {isA&&<div style={{display:"flex",gap:5,marginTop:8,flexWrap:"wrap"}}>
                    <Btn ch="✏️ Edit" oc={()=>{setModal("prod");setForm({...p});}} color={C.primary} out sm/>
                    <Btn ch="🗑️" oc={async()=>{if(!window.confirm(`Delete "${p.name}"?`))return;setProds(prods.filter(x=>x.id!==p.id));try{await API.deleteProduct(p.id);await loadData(true);showToast("Product deleted!");}catch(e){setProds(prods);showToast("❌ Delete failed: "+(e.message||"Server error"),"err");}}} color={C.danger} out sm/>
                  </div>}
                </Card>;
              })}
              </>;
            })()}
          </div>}

          {/* ── COMPANIES ── */}
          {page==="comps"&&isA&&<div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <div style={{fontSize:17,fontWeight:800}}>🏢 Companies ({companies.length})</div>
              <Btn ch="+ Add Company" oc={()=>{setModal("comp");setForm({color:CC[0],prefix:"INV",postfix:"",series_start:1});}}/>
            </div>
            {companies.map(co=><Card key={co.id} style={{marginBottom:8,borderLeft:`4px solid ${co.color||C.primary}`}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                    <div style={{width:28,height:28,borderRadius:8,background:co.color||C.primary,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:11,fontWeight:800,flexShrink:0}}>{co.short||co.name?.slice(0,3)}</div>
                    <div>
                      <div style={{fontWeight:700,fontSize:13}}>{co.name}</div>
                      <div style={{fontSize:10,color:C.sub}}>Prefix: {co.prefix||"INV"}{co.postfix?`-${co.postfix}`:""} • Series: #{co.series_start||1}</div>
                    </div>
                  </div>
                </div>
                <div style={{display:"flex",gap:5,flexWrap:"wrap",alignItems:"center"}}>
                  <Bdg l={co.active?"Active":"Inactive"} c={co.active?C.success:C.danger}/>
                  <Btn ch="✏️ Edit" oc={()=>{setModal("comp");setForm({...co});}} color={co.color} out sm/>
                  <Btn ch="🗑️" oc={async()=>{
                    if(!window.confirm(`Delete "${co.name}"? This cannot be undone.`)) return;
                    try{
                      await API.deleteCompany(co.id);
                      await loadData(true);
                      showToast("Company deleted!");
                    }catch(e){showToast("❌ "+e.message,"err");}
                  }} color={C.danger} out sm/>
                </div>
              </div>
            </Card>)}
          </div>}

      {modal==="batches"&&<Modal title="📅 Batch / Expiry Tracking" oc={()=>setModal(null)} w ch={<div>
        {(!batches||batches.length===0)&&<div style={{textAlign:"center",padding:30,color:C.sub,fontSize:12}}>
          No batches recorded yet.<br/>Add Batch No + Expiry Date when creating a Purchase entry.
        </div>}
        {batches&&batches.length>0&&<div style={{maxHeight:420,overflowY:"auto"}}>
          {batches.map(b=>{
            const days=b.expiry_date?Math.ceil((new Date(b.expiry_date)-new Date())/(1000*60*60*24)):null;
            const isExpired=days!==null&&days<0;
            const isSoon=days!==null&&days>=0&&days<=30;
            const color=isExpired?C.danger:isSoon?C.warning:C.success;
            return <div key={b.id} style={{background:"#fff",border:`1.5px solid ${color}30`,borderLeft:`4px solid ${color}`,borderRadius:10,padding:12,marginBottom:8}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                <div>
                  <div style={{fontWeight:700,fontSize:13}}>{b.product_name}</div>
                  <div style={{fontSize:11,color:C.sub,marginTop:2}}>
                    {b.batch_no?`Batch: ${b.batch_no}`:"No batch number"} • Qty: {b.qty}
                  </div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontSize:11,fontWeight:700,color}}>
                    {b.expiry_date?new Date(b.expiry_date).toLocaleDateString("en-IN",{day:"2-digit",month:"short",year:"numeric"}):"No expiry set"}
                  </div>
                  {days!==null&&<div style={{fontSize:10,color,fontWeight:600}}>
                    {isExpired?`⚠️ Expired ${Math.abs(days)}d ago`:isSoon?`⏳ ${days}d left`:`${days}d left`}
                  </div>}
                </div>
              </div>
              {isA&&<button onClick={async()=>{
                if(!window.confirm("Delete this batch record?"))return;
                try{await API.deleteBatch(b.id);await loadData(true);showToast("Batch deleted!");}
                catch(e){showToast("❌ "+(e.message||"Failed to delete"),"err");}
              }} style={{marginTop:6,background:"none",border:`1px solid ${C.border}`,color:C.sub,borderRadius:6,padding:"4px 10px",fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>🗑️ Delete</button>}
            </div>;
          })}
        </div>}
      </div>}/>}

      {modal==="suppPayHistory"&&<Modal title={`💰 Payment History — ${form.supp}`} oc={()=>setModal(null)} w ch={<div>
        {(()=>{
          const myPays=(suppPays||[]).filter(p=>p.supplier_name===form.supp).sort((a,b)=>(b.date||"").localeCompare(a.date||""));
          const totalPaid=myPays.reduce((s,p)=>s+(+p.amount||0),0);
          return <>
            <div style={{background:"#F0FDF4",borderRadius:9,padding:10,marginBottom:12,border:"1px solid #BBF7D0"}}>
              <div style={{fontSize:11,color:C.sub}}>Total Paid (All Time)</div>
              <div style={{fontSize:18,fontWeight:800,color:C.success}}>₹{fmt(totalPaid)}</div>
            </div>
            {myPays.length===0&&<div style={{textAlign:"center",padding:24,color:C.sub,fontSize:12}}>Koi payment record nahi mila abhi tak</div>}
            {myPays.length>0&&<div style={{maxHeight:400,overflowY:"auto"}}>
              {myPays.map(p=>(
                <div key={p.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:`1px solid ${C.border}`}}>
                  <div>
                    <div style={{fontWeight:700,fontSize:13}}>₹{fmt(p.amount)}</div>
                    <div style={{fontSize:10,color:C.sub}}>{(p.date||"").slice(0,10)} • {p.method||"Cash"}{p.ref_no?` • ${p.ref_no}`:""}</div>
                  </div>
                  {isA&&<button onClick={async()=>{
                    if(!window.confirm("Yeh payment delete karna hai? Supplier ka due wapas badh jaayega."))return;
                    try{await API.deleteSupplierPayment(p.id);await loadData(true);showToast("Payment deleted, due reversed!");}
                    catch(e){showToast("❌ Failed: "+(e.message||"Server error"),"err");}
                  }} style={{background:"none",border:`1px solid ${C.border}`,color:C.danger,borderRadius:6,padding:"5px 10px",fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>🗑️</button>}
                </div>
              ))}
            </div>}
          </>;
        })()}
      </div>}/>}

  </>);
}
